const KnCategoriesData = [
    {
      title: "ವಿಕಾಸ",
      subcategories: [
        {
          title: "ಜಾಲ ವಿಕಾಸ",
          popularTopics: [
            "ಜಾವಾಸ್ಕ್ರಿಪ್ಟ್", "ರಿಯಾಕ್ಟ್", "HTML/CSS", "MERN", "ಟೈಪ್‌ಸ್ಕ್ರಿಪ್ಟ್", "ನೋಡ್.js", "ಏಂಗುಲರ್", "ವ್ಯೂ.js", "ಸ್ವೆಲ್ಟ್"
          ]
        },
        {
          title: "ಮೊಬೈಲ್ ವಿಕಾಸ",
          popularTopics: [
            "ಫ್ಲಟರ್", "ರಿಯಾಕ್ಟ್ ನೆಟಿವ್", "ಸ್ವಿಫ್ಟ್", "ಕೋಟ್‌ಲಿನ್", "ಆಂಡ್ರಾಯ್ಡ್ ಸ್ಟುಡಿಯೊ", "iOS ವಿಕಾಸ", "ಜೇಮಿನ್", "ಐಒನಿಕ್"
          ]
        },
        {
          title: "ಪ್ರೋಗ್ರಾಮಿಂಗ್ ಭಾಷೆಗಳು",
          popularTopics: [
            "ಪೈಥಾನ್", "ಜಾವಾ", "C++", "ಜಾವಾಸ್ಕ್ರಿಪ್ಟ್", "ಗೋ", "ರೂಬಿ", "ರಸ್ಟ್", "ಸ್ವಿಫ್ಟ್", "C#", "PHP"
          ]
        },
        {
          title: "ಗೇಮ್ ವಿಕಾಸ",
          popularTopics: [
            "ಯೂನಿಟಿ", "ಅನ್‌ರಿಯಲ್ ಎಂಜಿನ್", "C#", "ಗೇಮ್ ಡಿಸೈನ್", "3D ಮಾದರೀಕರಣ", "AR/VR ವಿಕಾಸ", "ಬ್ಲೆಂಡರ್", "ಗೋಡೊಟ್"
          ]
        },
        {
          title: "ಡೇಟಾಬೇಸ್ ವಿನ್ಯಾಸ ಮತ್ತು ವಿಕಾಸ",
          popularTopics: [
            "SQL", "ಮೋಂಗೋಡಿಬಿ", "ಪೋಸ್ಟ್‌ಗ್ರೆಸ್ಸ್ಕ್ಯೂಎಲ್", "ಫೈರ್‌ಬೇಸ್", "ಡೇಟಾಬೇಸ್ ಆರ್ಕಿಟೆಕ್ಚರ್", "ನೋSQL", "ಗ್ರಾಫ್‌ಕ್ಯೂಎಲ್", "ಕ್ಯಾಸಾಂಡ್ರಾ"
          ]
        },
        {
          title: "ಸಾಫ್ಟ್‌ವೇರ್ ಪರೀಕ್ಷೆ",
          popularTopics: [
            "ಸೆಲೆನಿಯಂ", "ಯುನಿಟ್ ಪರೀಕ್ಷೆ", "ಪರೀಕ್ಷಣಾ ಸ್ವಚ್ಛತೆಯ", "API ಪರೀಕ್ಷೆ", "ಜುನೆಟ್", "ಕುಕುಂಬರ್", "ಸೈಪ್ರಸ್", "ಎಪಿಯಮ್"
          ]
        },
        {
          title: "ಸಾಫ್ಟ್‌ವೇರ್ ಎಂಜಿನಿಯರಿಂಗ್",
          popularTopics: [
            "ಸಾಫ್ಟ್‌ವೇರ್ ವಿನ್ಯಾಸ ಮಾದರಿಗಳು", "ಮೈಕ್ರೋಸರ್ವಿಸ್", "ಡೆವ್ಓಪ್ಸ್", "ಸಿಸ್ಟಮ್ ಆರ್ಕಿಟೆಕ್ಚರ್", "ಎಜೈಲ್", "ಸ್ಕ್ರಮ್", "CI/CD"
          ]
        },
        {
          title: "ಸಾಫ್ಟ್‌ವೇರ್ ಅಭಿವೃದ್ಧಿ ಸಲಕರಣೆಗಳು",
          popularTopics: [
            "ಗಿಟ್", "ಡೋಕರ್", "ಕ್ಯೂಬೆರ್ನೇಟ್ಸ್", "ಜೆನ್ಕಿಂಸ್", "CI/CD", "IDE", "ಟೆರಾಫಾರ್ಮ್", "ವ್ಯಾಗ್ರಾಂಟ್", "ಗಿಟ್ಲ್ಯಾಬ್"
          ]
        },
        {
          title: "ನೋ-ಕೋಡ್ ವಿಕಾಸ",
          popularTopics: [
            "ವೆಬ್‌ಫ್ಲೋ", "ಬಬಲ್", "ಆಡಾಲೊ", "ಜ್ಯಾಪಿಯರ್", "ಏರ್‌ಟೇಬಲ್", "ಇಂಟಿಗ್ರೊಮಾಟ್", "ಗ್ಲೈಡ್", "ಥ್ಯಾಂಕಬುಲ್"
          ]
        }
      ]
    },
    {
      title: "ವ್ಯಾಪಾರ",
      subcategories: [
        {
          title: "ಉದ್ಯಮಶೀಲತೆ",
          popularTopics: [
            "ಸ್ಟಾರ್ಟ್‌ಅಪ್", "ಫಂಡಿಂಗ್", "ವ್ಯಾಪಾರ ಮಾದರಿ", "ಉತ್ಪನ್ನ ನಿರ್ವಹಣೆ", "ಲೀನ್ ಸ್ಟಾರ್ಟ್‌ಅಪ್", "ಪಿಚಿಂಗ್", "ಸ್ಕೇಲಿಂಗ್"
          ]
        },
        {
          title: "ಮಾರುಕಟ್ಟೆ",
          popularTopics: [
            "B2B ಮಾರಾಟ", "ಬಾಣಿಜ್ಯದ ಚರ್ಚೆ", "ಲೀಡ್ ಉತ್ಪಾದನೆ", "CRM", "ಮಾರುಕಟ್ಟೆ ಫನಲ್", "ಕೋಲ್ಡ್ ಕಾಲ್", "ಇಮೇಲ್ ಮಾರುಕಟ್ಟೆ"
          ]
        },
        {
          title: "ನಾಯಕತ್ವ ಮತ್ತು ನಿರ್ವಹಣೆ",
          popularTopics: [
            "ಟೀಮ್ ನಿರ್ವಹಣೆ", "ನಾಯಕತ್ವದ ಕೌಶಲ್ಯ", "ಎಜೈಲ್ ನಾಯಕರ ಗುಣಲಕ್ಷಣಗಳು", "ನಿಯೋಜಿತ ಚಿಂತನೆ", "ಪ್ರಾಜೆಕ್ಟ್ ನಿರ್ವಹಣೆ", "OKRs"
          ]
        },
        {
          title: "ವ್ಯಾಪಾರ ವಿಶ್ಲೇಷಣೆ",
          popularTopics: [
            "ಡೇಟಾ ವಿಶ್ಲೇಷಣೆ", "ಪವರ್ BI", "ಟೇಬ್ಲೋ", "ಆರ್ಥಿಕ ಮಾದರೀಕರಣ", "ವ್ಯಾಪಾರ ಬುದ್ಧಿಮತ್ತೆ", "ಡೇಟಾ ವೀಕ್ಷಣಾ", "ಎಕ್ಸೆಲ್"
          ]
        }
      ]
    },
    {
      title: "ಹಣಕಾಸು ಮತ್ತು ಲೆಕ್ಕ",
      subcategories: [
        {
          title: "ಹಣಕಾಸು ಲೆಕ್ಕ",
          popularTopics: [
            "ಬ್ಯಾಲೆನ್ಸ್ ಶೀಟ್", "ಆಯ್ ಸೂಚಕ", "GAAP", "IFRS", "ಆಡಿಟಿಂಗ್", "ಬುಕ್ಕೀಪಿಂಗ್", "ಕರದ ಮೊತ್ತ", "ಕ್ವಿಕ್‌ಬುಕ್‌ಗಳು"
          ]
        },
        {
          title: "ಕಾರ್ಪೊರೇಟ್ ಹಣಕಾಸು",
          popularTopics: [
            "ರಾಜಧಾನಿ ಬಜೆಟ್", "ಕೋರ್ಪೊರೇಟ್ ಮೌಲ್ಯಮಾಪನ", "ಪರಿಕರ ನಿರ್ವಹಣೆ", "ಮಿಲನ ಮತ್ತು ಸ್ವೀಕಾರ", "ನಿವೇಶನ ಬ್ಯಾಂಕಿಂಗ್", "IPO"
          ]
        },
        {
          title: "ವ್ಯಕ್ತಿಗತ ಹಣಕಾಸು",
          popularTopics: [
            "ಬಜೆಟಿಂಗ್", "ಉಳಿತಾಯ", "ನಿವೇಶ", "ಅಪರಾಧ ಯೋಜನೆ", "ಹಣಕಾಸು ಸ್ವಾಯತ್ತತೆ", "ರಿಯಲ್ ಎಸ್ಟೇಟ್", "ಶೇರುಗಳು"
          ]
        }
      ]
    },
    {
      title: "ಐಟಿ ಮತ್ತು ಸಾಫ್ಟ್‌ವೇರ್",
      subcategories: [
        {
          title: "ಕ್ಲೌಡ್ ಕಂಪ್ಯೂಟಿಂಗ್",
          popularTopics: [
            "AWS", "ಏಜುರ್", "ಗೂಗಲ್ ಕ್ಲೌಡ್", "ಕ್ಯೂಬರ್‌ನೆಟ್ಸ್", "ಸರ್ವರ್‌ಲೆಸ್ ಆರ್ಕಿಟೆಕ್ಚರ್", "ಕ್ಲೌಡ್ ಭದ್ರತಾ", "ಡೆವ್‌಑ಪ್ಸ್", "ಓಪನ್‌ಶಿಫ್ಟ್"
          ]
        },
        {
          title: "ಸೈಬರ್ ಭದ್ರತೆ",
          popularTopics: [
            "ನೈತಿಕ ಹ್ಯಾಕಿಂಗ್", "ಪೆನೆಟ್ರೇಶನ್ ಪರೀಕ್ಷೆ", "ಜಾಲ ಭದ್ರತೆ", "ಕ್ರಿಪ್ಟೋಗ್ರಫಿ", "ಸೈಬರ್ ಅಪಾಯ", "ಫೈರ್‌ವಾಲ್", "SOC"
          ]
        },
        {
          title: "ಜಾಲ ವ್ಯವಸ್ಥೆ",
          popularTopics: [
            "CCNA", "ಜಾಲ ನಿಯಮಗಳು", "ಸಿಸ್ಕೋ", "SDN", "ಜಾಲ ಭದ್ರತೆ", "ರೂಟಿಂಗ್", "VPN", "ಸ್ವಿಚಿಂಗ್"
          ]
        }
      ]
    },
    {
      title: "ವಿಷಯೋದ್ಯಮ",
      subcategories: [
        {
          title: "ಗ್ರಾಫಿಕ್ ವಿನ್ಯಾಸ",
          popularTopics: [
            "ಫೋಟೋಶಾಪ್", "ಇಲಸ್ಟ್ರೇಟರ್", "ಇಂಡಿಸೈನ್", "ಕ್ಯಾನ್ವಾ", "ಟೈಪೋಗ್ರಫಿ", "ಬಣ್ಣ ತತ್ವ", "ಲೋಗೋ ವಿನ್ಯಾಸ", "ಬ್ರಾಂಡಿಂಗ್"
          ]
        },
        {
          title: "UI/UX ವಿನ್ಯಾಸ",
          popularTopics: [
            "ಫಿಗ್ಮಾ", "ಎಡೋಬ್ XD", "ಸ್ಕೆಚ್", "ವಾಯರ್‌ಫ್ರೇಮಿಂಗ್", "ಪ್ರೋಟೋಟೈಪಿಂಗ್", "ಬಳಕೆದಾರರ ಸಂಶೋಧನೆ", "ಬಳಕೆದಾರಿತ್ವ ಪರೀಕ್ಷೆ"
          ]
        },
        {
          title: "3D ಮತ್ತು ಎನಿಮೇಶನ್",
          popularTopics: [
            "ಬ್ಲೆಂಡರ್", "ಮಾಯಾ", "3ds ಮ್ಯಾಕ್ಸ್", "ಸಿನೆಮಾ 4D", "ಆಫ್ಟರ್ ಎಫೆಕ್ಟ್ಸ್", "ಮೋಶನ್ ಗ್ರಾಫಿಕ್ಸ್", "ಅಕ್ಷರ ಎನಿಮೇಶನ್"
          ]
        }
      ]
    },
    {
      title: "ಮಾರುಕಟ್ಟೆ",
      subcategories: [
        {
          title: "ಡಿಜಿಟಲ್ ಮಾರುಕಟ್ಟೆ",
          popularTopics: [
            "SEO", "ಗೂಗಲ್ ಜಾಹೀರಾತು", "ಫೇಸ್ಬುಕ್ ಜಾಹೀರಾತು", "ವಿಷಯ ಮಾರುಕಟ್ಟೆ", "ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ ಮಾರುಕಟ್ಟೆ", "PPC", "ಪ್ರಭಾವಕಾರಿ ಮಾರುಕಟ್ಟೆ"
          ]
        },
        {
          title: "ಅಫಿಲಿಯೇಟ್ ಮಾರುಕಟ್ಟೆ",
          popularTopics: [
            "ಅಫಿಲಿಯೇಟ್ ನೆಟ್ವರ್ಕ್", "ಕಮಿಷನ್ ಟ್ರ್ಯಾಕಿಂಗ್", "ಉತ್ಪನ್ನ ವಿಮರ್ಶೆ", "ಅಫಿಲಿಯೇಟ್ ಗೆ SEO", "ಇಮೇಲ್ ಅಭಿಯಾನ"
          ]
        },
        {
          title: "ಬ್ರಾಂಡಿಂಗ್",
          popularTopics: [
            "ಬ್ರಾಂಡ್ ಹೀಗಿಂತಲು", "ಬ್ರಾಂಡ್ ಗುರುತು", "ಬ್ರಾಂಡ್ ನ ಉರಿಯ", "ಗ್ರಾಹಕ ಪಾಲ್ಗೊಳ್ಳುವಿಕೆ", "ಪುನಃ ಬ್ರಾಂಡಿಂಗ್", "PR", "ಕಥೆ ಹೇಳುವುದು"
          ]
        }
      ]
    }
  ];
  
  export default KnCategoriesData;
  